import React from 'react';
import PropTypes from 'prop-types';
import Link, { LINK_SIZES } from 'components/Link';
import EmployeeCard from 'components/EmployeeCard';
import EmployeeType from 'types/EmployeeType';
import Anchor from 'components/Anchor';
import './LatestChroniclesBlock.scss';

const VIEWS = {
  EMPLOYEE: 'employee',
  MARKETGROUP: 'marketgroup',
  PRESSTOPCONTACT: 'presstopcontact',
};

const chronicleType = PropTypes.shape({
  url: PropTypes.string,
  heading: PropTypes.string,
  intro: PropTypes.string,
  author: PropTypes.exact({
    ...EmployeeType,
    view: PropTypes.oneOf([
      VIEWS.EMPLOYEE,
      VIEWS.MARKETGROUP,
      VIEWS.PRESSTOPCONTACT,
    ]),
    className: PropTypes.string,
    negative: PropTypes.bool.isRequired,
    customDownloadLink: PropTypes.exact(Link.propTypes),
  }),
});

import cn from 'classnames';

const themes = {
  shortView: 'short-view',
};

const LatestChroniclesBlock = ({
  heading,
  chronicles,
  seeAllLink,
  theme,
  anchor,
}) => {
  const isShortView = theme === themes.shortView;
  return (
    <div
      className={cn('latest-chronicles-block', {
        [`latest-chronicles-block_theme_${theme}`]: theme,
      })}
    >
      {heading && !isShortView && (
        <h2 className="latest-chronicles-block__heading h4">
          {anchor && <Anchor {...anchor} />}
          {heading}
        </h2>
      )}
      {seeAllLink && (
        <Link
          {...seeAllLink}
          className="latest-chronicles-block__see-all-link"
        />
      )}
      {chronicles && (
        <ul className="latest-chronicles-block__items">
          {chronicles.map((chronicle, index) => (
            <li key={index} className="latest-chronicles-block__item">
              <div className="latest-chronicles-block__chronicle">
                {chronicle.heading && (
                  <h3 className="latest-chronicles-block__chronicle-heading">
                    <Link
                      url={chronicle.url}
                      text={chronicle.heading}
                      {...(isShortView && {
                        size: LINK_SIZES.small,
                      })}
                      className="latest-chronicles-block__chronicle-link"
                    />
                  </h3>
                )}

                {chronicle.intro && (
                  <div
                    className="latest-chronicles-block__chronicle-intro typo-small wysiwyg"
                    dangerouslySetInnerHTML={{
                      __html: chronicle.intro.stripHtmlTags(),
                    }}
                  />
                )}
                {chronicle.author && !isShortView && (
                  <EmployeeCard {...chronicle.author} negative={false} />
                )}
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

LatestChroniclesBlock.propTypes = {
  anchor: PropTypes.exact(Anchor.propTypes),
  heading: PropTypes.string,
  seeAllLink: PropTypes.exact(Link.propTypes),
  chronicles: PropTypes.arrayOf(PropTypes.shape(chronicleType)),
  theme: PropTypes.oneOf(Object.values(themes)),
};

export default LatestChroniclesBlock;
